/**
 * Created by hp on 2017/8/4.
 */
const defaults = {
    initialized: false,
    subscribedCategoryFlag: false,
    selectCategory: 0,
    page: 1,
    livingPage: 2,
    showPopupTab: false,
    cacheData: null,
    isTabFixTop: false,
    giftPopupShow: false,
    isTabSubscribed: false,
    isShowShuangqian: false,
};

export default (state = defaults, action) => {
    switch (action.type) {
        case 'MAIN_INIT_DATA':
            return {...state, initialized: true, ...action.payload, cacheData: null};
        case 'MAIN_UNSET_DATA':
            return {...state, initialized: false};
        case 'MAIN_SELECT_CATEGORY':
            return {...state, selectCategory: action.payload, page: 1, livingPage: 2};
        case 'MAIN_SHOW_POPUP_TAB':
            return {...state, showPopupTab: true};
        case 'MAIN_HIDE_POPUP_TAB':
            return {...state, showPopupTab: false, isTabSubscribed: false};
        case 'MAIN_SUBSCRIBE_CATEGORY':
            state.category.data.subd = action.payload.mineCategories;
            state.category.data.all = action.payload.allCategories;
            return {...state, category: state.category, subscribedCategoryFlag: !state.subscribedCategoryFlag, isTabSubscribed: true};
        case 'MAIN_NEXT_PAGE':
            return {...state, page: state.page + 1};
        case 'livingPage':
            return {...state, livingPage: state.livingPage + 1};
        case 'MAIN_CACHE_PAGE':
            return {...state, page: action.payload + 1};
        case 'MAIN_LOAD_MORE_DATA':
            state.recommend.data.has_more = action.payload.hasMore;
            state.recommend.data.ret = [...state.recommend.data.ret, ...action.payload.ret];
            return {...state, recommend: state.recommend, cacheData: action.payload.cacheData};
        case 'MAIN_LOAD_LIVING_DATA':
            state.starting.data.has_more = action.payload.hasMore;
            state.starting.data.ret = [...state.starting.data.ret, ...action.payload.ret];
            return {...state, starting: state.starting, livingPage: state.livingPage + 1};
        case 'MAIN_CACHE_TOP':
            state.cacheData.top = action.payload;
            return {...state, cacheData: state.cacheData};
        case 'MAIN_SET_RECOMMEND_CACHE':
            state.recommend.data.has_more = action.payload.hasMore;
            state.recommend.data.ret = action.payload.ret;
            return {...state, recommend: state.recommend};
        case 'MAIN_SET_CATEGORY_TOP':
            return {...state, isTabFixTop: true};
        case 'MAIN_UNSET_CATEGORY_TOP':
            return {...state, isTabFixTop: false};
        case 'MAIN_SHOW_GIFT_POPUP':
            return {...state, giftPopupShow: true};
        case 'MAIN_HIDE_GIFT_POPUP':
            return {...state, giftPopupShow: false};
        case 'MAIN_SET_IS_SHOW_SHUANGQIAN':
            return {...state, isShowShuangqian: action.payload};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/main.js